import type { ReactNode } from 'react'

/**
 * The detail-page layout: `top` and `children` stack in the main column, `side` sits in a
 * 340px column next to them on wide screens and right after `top` on narrow ones. Without
 * `top`, `children` come first on narrow screens.
 */
export function DetailPageGrid({
  top,
  side,
  children,
}: {
  top?: ReactNode
  side: ReactNode
  children: ReactNode
}) {
  const aside = (
    <aside className="min-w-0 space-y-4 xl:col-start-2 xl:row-span-2 xl:row-start-1">{side}</aside>
  )
  return (
    <div className="grid gap-6 xl:grid-cols-[minmax(0,1fr)_340px] xl:grid-rows-[auto_1fr] xl:items-start">
      {top ? (
        <>
          <div className="min-w-0 space-y-6 xl:col-start-1 xl:row-start-1">{top}</div>
          {aside}
          <div className="min-w-0 space-y-6 xl:col-start-1 xl:row-start-2">{children}</div>
        </>
      ) : (
        <>
          <div className="min-w-0 space-y-6 xl:col-start-1 xl:row-span-2 xl:row-start-1">
            {children}
          </div>
          {aside}
        </>
      )}
    </div>
  )
}
